import { render, staticRenderFns } from "./PlayerScreenshotPreview.vue?vue&type=template&id=0c37a33f&scoped=true&"
import script from "./PlayerScreenshotPreview.vue?vue&type=script&lang=ts&"
export * from "./PlayerScreenshotPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerScreenshotPreview.vue?vue&type=style&index=0&id=0c37a33f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c37a33f",
  null
  
)

export default component.exports